import { BodyLBold, BodySReg } from "../typographic";
import { cn } from "@/lib/utils";

export const SummaryItem = ({
  caption,
  value,
  labelClassName,
  valueClassName,
  children,
  className,
}: {
  caption: string;
  value?: string;
  labelClassName?: string;
  valueClassName?: string;
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <section className={cn("flex flex-col items-start gap-4", className)}>
      <BodySReg className={labelClassName}>{caption}</BodySReg>
      {value && (
        <BodyLBold className={cn(valueClassName, "text-left")}>
          {value}
        </BodyLBold>
      )}
      {children}
    </section>
  );
};
